import React from 'react';
import isNil from 'lodash-es/isNil';
import { gql } from '@yi/core';

import { graphql, useStaticQuery } from 'gatsby';

import { PranayamasCarousel } from '../../PranayamasCarousel';
import { sortCardsByIds } from '../sortCardsByIds';

interface Props {
  children: (data: React.ComponentProps<typeof PranayamasCarousel>['items']) => React.ReactNode;
}
const list = [
  // Moment of Connected Stillness	Amy Ippoliti
  '61fbF7eaBxjT0DaonziMWi',
  // Pep In Your Step	Dianne Bondy
  '5ki25FdlJqmqdURcrJN3e8',
  // I am Loved	Sierra Hollister
  '5Ek83L4IL5DVOE3WJtBkY6',
  // Morning Brew	Jim Bennitt
  '48SqcAxbpG6O6tXbaiytX8',
  // Connect With Yourself	Anisha Chirmule
  '5NaUYV5a3PikdbPFTnBCID',
  // Breathwork for Brain Chatter	Rodney Yee
  '22Ae2aStUp1BQES83qhyU',
  // Take Up Space	Oneika Mays
  '5q83XF8JtzuS1rx5xQXfn7',
  // Morning Vibes	Reggie Hubbard
  '2PozijttLHr2ibGPipQF3G',
  // Micro Retreat	Miles Borrero
  'SGEeJZoaPVrK7b8tFCU8v',
  // Bring Your Mind Back Home	Luke Ketterhagen
  '2acWhN9ieI6JQkx2qTVinM',
  // Expansive Lungs	Amy Ippoliti
  '3Wpg1McylKkVvG5BlkE1n0',
  // High Octane	Jim Bennitt
  '6eIRuhiFrrMujNHHH1qxWu',
];

export const BreathworkCarouselDataEN: React.FC<Props> = ({ children }) => {
  const yiData = useStaticQuery<gql.typesSsr.Query_AllBreathworks_LOH_EN>(graphql`
    query Query_AllBreathworks_LOH_EN {
      yi {
        allClasses(
          filter: {
            ids: [
              "61fbF7eaBxjT0DaonziMWi"
              "5ki25FdlJqmqdURcrJN3e8"
              "5Ek83L4IL5DVOE3WJtBkY6"
              "48SqcAxbpG6O6tXbaiytX8"
              "5NaUYV5a3PikdbPFTnBCID"
              "22Ae2aStUp1BQES83qhyU"
              "5q83XF8JtzuS1rx5xQXfn7"
              "2PozijttLHr2ibGPipQF3G"
              "SGEeJZoaPVrK7b8tFCU8v"
              "2acWhN9ieI6JQkx2qTVinM"
              "3Wpg1McylKkVvG5BlkE1n0"
              "6eIRuhiFrrMujNHHH1qxWu"
            ]
          }
        ) {
          ...Fragment_ClassCard
        }
      }
    }
  `);

  const data = yiData?.yi?.allClasses;
  if (isNil(data)) {
    return null;
  }
  const sortedClassesData = sortCardsByIds(data, list);

  return <>{children(sortedClassesData)}</>;
};
